import React from 'react';
import '../styles/global.css';
import ThemeToggle from '../components/ThemeToggle';
import { motion } from 'framer-motion';


function Privacy() {
  return (
    <div className="app">
      <header className="hero-header">
        <div className="container">
          <h1>Our Privacy Promise</h1>
        </div>
      </header>

      <main className="container">
        <section className="privacy-section">
          <div className="card">
            <div className="privacy-pledge">
              <h2>Your Stories, Your Data</h2>
              <p>At My Abnormal Story, we believe your personal health journey belongs to you. We commit to:</p>
              
              <ul>
                <li><strong>Never selling your data</strong> to third parties, advertisers, or data brokers</li>
                <li><strong>Using information anonymously</strong> for research purposes only with explicit consent</li>
                <li><strong>Providing anonymous sharing options</strong> that don't require personal identification</li>
                <li><strong>Maintaining HIPAA-inspired protections</strong> even though we're not a medical provider</li>
                <li><strong>Transparency about how analytics</strong> are generated and used to help others</li>
              </ul>
            </div>
            
            <div className="data-usage">
              <h2>How We Use Your Information</h2>
              <p>Information shared through My Abnormal Story is used exclusively for:</p>
              
              <ul>
                <li>Displaying your story (when approved) to provide hope and information to others</li>
                <li>Aggregating anonymous treatment outcomes to identify potential patterns</li>
                <li>Creating research reports that never identify individual contributors</li>
                <li>Improving the platform's functionality and user experience</li>
              </ul>
              
              <p>You maintain control of your story, with options to edit or remove it at any time.</p>
            </div>
          </div>
        </section>
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.5 }}
      >
        <ThemeToggle />
      </motion.div>
      </main>

      <footer className="site-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <p>© {new Date().getFullYear()} My Abnormal Story</p>
              <p className="footer-tagline">
                Sharing alternative cancer treatment journeys to inspire hope
              </p>
            </div>
            <div className="footer-links">
              <a href="/" className="admin-link">Home</a>
              <a href="/about" className="admin-link">About Us</a>
              <a href="/resources" className="admin-link">Resources</a>
              <a href="/admin-login" className="admin-link">Admin</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Privacy;